export default class UnauthenticatedError extends Error {
	constructor(message) {
		super(message)
		this.name = 'UnauthenticatedError'
	}
}
